
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 34 34","height":"60","width":"61"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('g',{attrs:{"fill-rule":"evenodd","fill":"none"}},[_c('path',{attrs:{"vector-effect":"non-scaling-stroke","d":"M0 0h32v32H0z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M24.322 23.233l-7.28-7.235 7.223-7.233a.75.75 0 00-1.062-1.06l-7.225 7.236-7.243-7.197a.751.751 0 00-1.058 1.064l7.24 7.195-7.22 7.23a.751.751 0 001.061 1.06l7.223-7.233 7.283 7.237a.752.752 0 001.061-.003.751.751 0 00-.003-1.061","vector-effect":"non-scaling-stroke"}})])])])
          )
        }
      }
    